var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from '../framework/Framework';
import { Component } from '../framework/Component';
import { Lightbox } from '../tools/lighboxCompare';
export class PortalComponent extends Component {
    constructor() {
        super('PortalComponent', false);
        this.displayMode = 'visual';
        this.sortMode = 'french';
        this.cart = [];
        this.activeFiltersCount = 0;
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            Lightbox.init();
            this.initDefaultView();
            this.initDataSwitch();
            this.initFilterList();
            this.initVisualSwitch();
            this.initSort();
            this.initFilterButtons();
            this.initListRefresh();
            this.initCart();
            this.success();
        });
    }
    /*
     * default view
     */
    initDefaultView() {
        $('.button-toggle-group').on('click', (event, item) => {
            event.preventDefault();
            $(item).parents('.group').find('.button-toggle-group').toggleClass('active');
            $(item).parents('.group').toggleClass('opened');
        });
    }
    /*
     * Show/Hide filter list
     */
    initFilterList() {
        $('#button-toggle-filters').on('click', (event, item) => {
            event.preventDefault();
            $(item).toggleClass('active');
            $('#filters').toggleClass('d-none');
            $('#species-results').toggleClass('inactive');
            let filterHeight = $('#filters').get(0).getBoundingClientRect().height;
            $('#default-list, #filter-list').forEach((list) => {
                list.style.setProperty('min-height', filterHeight + 'px');
            });
        });
        $('#button-close-filters').on('click', (event) => {
            event.preventDefault();
            $('#species-results').removeClass('inactive');
            $('#button-toggle-filters').removeClass('active');
            $('#filters').addClass('d-none');
            $('#default-list, #filter-list').forEach((list) => {
                list.style.removeProperty('min-height');
            });
            scrollTo(0, $('#row-search').get(0).getBoundingClientRect().y + window.pageYOffset - $('header').get(0).getBoundingClientRect().height - 15);
        });
    }
    /*
     * Data mode switching
     */
    initDataSwitch() {
        $('.toggle-data-mode').on('click', (event, item) => {
            event.preventDefault();
            this.dataMode = $(item).data('mode');
            $('.toggle-data-mode').removeClass('button-primary');
            $(item).addClass('button-primary');
            if (this.dataMode == 'sheet') {
                $('.toggle-display-mode[data-display-mode="visual"]').removeClass('disabled');
                $('#cart, #button-add-all').addClass('d-none');
                $('#filter-list .species-lis').addClass('col-12 presentation-column-large').removeClass('col-md-8 col-xl-9 presentation-column-narrow');
            }
            else {
                $('.toggle-display-mode[data-display-mode="visual"]').addClass('disabled');
                if (this.displayMode == 'visual')
                    $('.toggle-display-mode[data-display-mode="list"]').trigger('click');
                $('#cart, #button-add-all').removeClass('d-none');
                $('#filter-list .species-list').addClass('col-md-8 col-xl-9 presentation-column-narrow').removeClass('col-12 presentation-column-large');
            }
            sessionStorage.setItem('portal-data-mode', this.dataMode);
        });
        const portalDataMode = sessionStorage.getItem('portal-data-mode');
        let target = (portalDataMode) ? portalDataMode : 'sheet';
        $('.toggle-data-mode[data-mode="' + target + '"]').trigger('click');
    }
    /*
     * display mode switching
     */
    initVisualSwitch() {
        $('.toggle-display-mode').on('click', (event, item) => __awaiter(this, void 0, void 0, function* () {
            event.preventDefault();
            if ($(item).hasClass('disabled'))
                return;
            this.displayMode = $(item).data('displayMode');
            $('.toggle-display-mode').removeClass('button-primary');
            $(item).addClass('button-primary');
            $('#default-list, #filter-list').forEach((item) => {
                item.style.opacity = '0';
            });
            yield $.httpRequest({
                url: '?display_mode=' + this.displayMode,
                type: 'POST',
                dataType: 'json',
            });
            FWP.refresh();
            sessionStorage.setItem('portal-display-mode', this.displayMode);
        }));
        const portalDisplayMode = sessionStorage.getItem('portal-display-mode');
        let target = (portalDisplayMode) ? portalDisplayMode : 'visual';
        $('.toggle-display-mode[data-display-mode="' + target + '"]').trigger('click');
    }
    /*
     *
     */
    initSort() {
        $('.toggle-sort-mode').on('click', (event, item) => {
            event.preventDefault();
            if ($(item).hasClass('disabled'))
                return;
            this.sortMode = $(item).data('sortMode');
            $('.toggle-sort-mode').removeClass('button-primary');
            $(item).addClass('button-primary');
            $('.species-list-french, .species-list-latin').addClass('d-none');
            $('.species-list-' + this.sortMode).removeClass('d-none');
            this.manageSorting();
            setTimeout(() => {
                this.manageSorting();
            }, 500);
            sessionStorage.setItem('portal-sort-mode', this.sortMode);
        });
        const portalSortMode = sessionStorage.getItem('portal-sort-mode');
        let target = (portalSortMode) ? portalSortMode : 'french';
        $('.toggle-sort-mode[data-sort-mode="' + target + '"]').trigger('click');
    }
    /*
     * Suppress filter when click on list
     */
    initFilterButtons() {
        let delayFWPUpdate = false;
        $(document).on('click', '.current-filter', (event, item) => {
            event.preventDefault();
            const value = $(item).data('value');
            $(item).get(0).style.setProperty('opacity', '.25');
            if (value == 'search') {
                $('.facetwp-search').get(0).value = '';
                if (!delayFWPUpdate)
                    FWP.refresh();
            }
            else {
                $('.facetwp-checkbox[data-value="' + $(item).data('value') + '"]').trigger('click');
            }
        });
        $('#button-clear-filter').on('click', (event) => {
            event.preventDefault();
            FWP.reset();
            /*delayFWPUpdate = true;
            FWP.auto_refresh = false;
      
            $('.current-filter').forEach((item: Elem) => {
              console.log(item);
              $(item).trigger('click');
            });
      
            delayFWPUpdate = false;
      
            setTimeout(() => {
              //FWP.auto_refresh = true;
              //FWP.refresh();
            }, 100);*/
        });
    }
    /*
     * Refresh list on filter change
     */
    addCustomFilter(value, title) {
        if (!title) {
            title = $('.facetwp-checkbox[data-value="' + value + '"]').text().replace(/\([0-9A-Z\-\>]+\)/gi, '');
            title = title.replace(' cr', '');
            title = title.replace(' en', '');
            title = title.replace(' vu', '');
            title = title.replace(' nt', '');
            title = title.replace(' lc', '');
            title = title.replace(' na', '');
        }
        if (title == 'Jan ')
            title = 'Janvier';
        if (title == 'Fév ')
            title = 'Février';
        if (title == 'Mar ')
            title = 'Mars';
        if (title == 'Avr ')
            title = 'Avril';
        if (title == 'Mai ')
            title = 'Mai';
        if (title == 'Jun ')
            title = 'Juin';
        if (title == 'Jul ')
            title = 'Juillet';
        if (title == 'Aoû ')
            title = 'Août';
        if (title == 'Sep ')
            title = 'Septembre';
        if (title == 'Oct ')
            title = 'Octobre';
        if (title == 'Nov ')
            title = 'Novembre';
        if (title == 'Déc ')
            title = 'Décembre';
        const button = $.parseHTML('<a href="#" class="current-filter button button-small button-white mt-1 mr-1" data-value="' + value + '">' + title + '<span class="badge">✕</span></a>');
        $('#current-filters').append(button);
        this.activeFiltersCount++;
    }
    initListRefresh() {
        $(document).on('facetwp-loaded', () => {
            $('#current-filters').empty();
            this.activeFiltersCount = 0;
            for (const [key, values] of Object.entries(FWP.facets)) {
                if (typeof values == 'string') {
                    if (values != '' && values != 'title_fr' && values != 'title_lt')
                        this.addCustomFilter('search', values);
                }
                else if (typeof values == 'object') {
                    values.forEach((value) => {
                        this.addCustomFilter(value);
                    });
                }
            }
            if (this.activeFiltersCount > 0) {
                $('#button-clear-filter').removeClass('d-none');
            }
            else {
                $('#button-clear-filter').addClass('d-none');
            }
            $('#counter-results').text(FWP.settings.pager.total_rows.toString());
            $('#filter-list').removeClass('display-visual display-list').addClass('display-' + this.displayMode);
            $('.facetwp-template > div').forEach((element) => {
                let children = $(element).find('.species');
                if (children.length < 4) {
                    $(element).addClass('no-break');
                }
                else {
                    $(element).removeClass('no-break');
                }
                if (children.length > 0) {
                    $('#button-add-all').removeClass('disabled');
                }
                else {
                    $('#button-add-all').addClass('disabled');
                }
            });
            this.buildCart();
            this.switchLists();
        });
    }
    /*
     * Panier
     */
    initCart() {
        $(document).on('click', '.species', (event, item) => {
            if (this.dataMode != 'sheet') {
                event.preventDefault();
                var reference = '#' + $(item).attr('id');
                var cartObject = {
                    reference: reference,
                    text: item.innerHTML
                };
                var existingItem = this.cart.findIndex((item) => {
                    return item.reference == reference;
                });
                if (existingItem > -1) {
                    this.cart.splice(existingItem, 1);
                }
                else {
                    this.cart.push(cartObject);
                }
                this.buildCart();
                sessionStorage.setItem('portal-cart', JSON.stringify(this.cart));
            }
        });
        $(document).on('click', '#cart-list a', (event, item) => {
            event.preventDefault();
            let reference = $(item).parent().data('reference');
            var existingItem = this.cart.findIndex((item) => {
                return item.reference == reference;
            });
            if (existingItem > -1) {
                this.cart.splice(existingItem, 1);
            }
            this.buildCart();
        });
        $('#button-add-all').on('click', (event, item) => {
            event.preventDefault();
            this.cart = [];
            $('.species').trigger('click');
            $('#button-add-all').addClass('disabled');
        });
        $('#button-clear-cart-list').on('click', (event, item) => {
            event.preventDefault();
            this.cart = [];
            this.buildCart();
            $('#button-add-all').removeClass('disabled');
        });
        $('#button-view-selection').on('click', (event, item) => {
            event.preventDefault();
            Lightbox.compare(this.dataMode, this.cart);
        });
        var storedCart = sessionStorage.getItem('portal-cart');
        if (storedCart) {
            this.cart = JSON.parse(storedCart);
            this.buildCart();
        }
    }
    buildCart() {
        this.clearCart();
        this.cart.forEach((item) => {
            const cartItem = $.parseHTML('<div data-reference="' + item.reference + '">' + item.text + ' <a class="badge">✕</a></div>');
            $(item.reference).addClass('selected');
            $('#cart-list').append(cartItem);
        });
        if (this.cart.length < 2) {
            $('#button-view-selection, #button-clear-cart-list').addClass('d-none');
        }
        else {
            $('#button-view-selection, #button-clear-cart-list').removeClass('d-none');
        }
    }
    /*
     * switch betwen group and filter lists
     */
    switchLists() {
        var activeList = 'default';
        if (this.displayMode == 'visual') {
            activeList = 'default';
            if (this.activeFiltersCount > 0)
                activeList = 'filter';
        }
        else {
            activeList = 'filter';
        }
        if (activeList == 'default') {
            $('#default-list').removeClass('d-none').get(0).style.opacity = '1';
            $('#filter-list').addClass('d-none');
        }
        else {
            $('#default-list').addClass('d-none');
            $('#filter-list').removeClass('d-none').get(0).style.opacity = '1';
        }
    }
    manageSorting() {
        if ($('.facetwp-sort-select').length == 0)
            return;
        $('.facetwp-sort-select').get(0).value = (this.sortMode == 'latin') ? 'title_lt' : 'title_fr';
        $('.facetwp-sort-select').trigger('change');
    }
    clearCart() {
        $('#cart-list').empty();
        $('.species').removeClass('selected');
    }
}
